"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandConfiguration = void 0;
var React = require("react");
var getBrandConfiguration = function (brandData) {
    var iconSet = (brandData && brandData.iconData) || null;
    var getIconData = function (name) {
        if (!iconSet || (!iconSet.icons[name] && !iconSet.nameMapping[name])) {
            return null;
        }
        return iconSet.nameMapping[name] || name;
    };
    var getIconPath = function (name) {
        var iconDataVal = getIconData(name);
        if (!iconDataVal) {
            return null;
        }
        return iconSet.icons[iconDataVal].data;
    };
    var getIcon = function (name) {
        var iconDataVal = getIconData(name);
        if (!iconDataVal) {
            return null;
        }
        // eslint-disable-next-line react/display-name
        return function (props) {
            var innerSvgProps = __assign({ dangerouslySetInnerHTML: { __html: iconSet.icons[iconDataVal].data } }, props);
            return React.createElement("svg", __assign({}, innerSvgProps));
        };
    };
    return {
        getIcon: getIcon,
        getIconPath: getIconPath,
    };
};
exports.getBrandConfiguration = getBrandConfiguration;
//# sourceMappingURL=brand-config.js.map